// import Vue from "vue";
import axios from "axios";
import qs from "qs"; // 引入qs模块，用来序列化post类型的数据，后面会提到
import router from "@/router/index";
import Vue from "vue";
import store from "../store/index";
import { Message, Loading } from "element-ui";

axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
let service = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});
let timer = null;
//添加请求拦截器
service.interceptors.request.use(
  (config) => {
    // console.log(config)
    if (config.url !== "/fillmed-club-auth/user/login") {
      let token = localStorage.getItem("token");
      config.headers["Authorization"] = token ? "Bearer " + token : "";
    }
    // console.log('config',config)
    return config;
  },
  function(error) {
    console.log(error);
    return Promise.reject(error);
  }
);
//添加响应拦截器
service.interceptors.response.use(
  (response) => {
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
     */

    let res = response.data;
    if (res.code === "5001") {
      router.replace({
        path: "/",
      });
      Vue.prototype.$loading().close();
      store.commit("changeEditTabs", "/index");
      store.commit("changeTagsList", [
        {
          title: "首页",
          name: "/index",
        },
      ]);
      store.commit("changeActIndex", 1);
      sessionStorage.clear();
      localStorage.clear();
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        Message({
          message: "已退出登陆",
          type: "error",
          duration: 1000,
        });
      }, 500);
    }
    return res;

    // if (!res.flag) {
    //   Message({
    //     message: res.message,
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    // }
  },
  (error) => {
    console.log("error", error);
    Message({
      message: error.message,
      type: "error",
      duration: 1000,
    });
    return Promise.reject(error);
  }
);

//post请求
export let post = (url, param, param1 = {}) => {
  return new Promise((resolve, reject) => {
    service({
      method: "post",
      url,
      data: param,
      ...param1,
    })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
      });
  });
};
//get请求
export let get = (url, param) => {
  return new Promise((resolve, reject) => {
    service({
      method: "get",
      url,
      params: param,
    })
      .then((res) => {
        //axios返回的是一个promise对象
        resolve(res); //resolve在promise执行器内部
      })
      .catch((err) => {
        Message({
          message: err.message,
          type: "error",
          duration: 1000,
        });
      });
  });
};



// WEBPACK FOOTER //
// ./src/api/axios.js